import { InternetConnectionType } from '@/signalr';

const NO_CONNECTION_TEXTS: Record<string, string> = {
  en: 'No connection',
  cs: 'Žádné připojení',
  de: 'Keine Verbindung',
  hu: 'Nincs kapcsolat',
  it: 'Nessuna connessione',
  ro: 'Lipsă conexiune',
  'ro-MD': 'Lipsă conexiune',
  sk: 'Žiadne spojenie',
};

function noConnectionText(language: string): string {
  return (
    NO_CONNECTION_TEXTS[language] ??
    NO_CONNECTION_TEXTS[language.split('-')[0] ?? ''] ??
    NO_CONNECTION_TEXTS['en']!
  );
}

export function internetConnectionTypeToText(
  connectionType: InternetConnectionType,
  language: string,
): string {
  switch (connectionType) {
    case InternetConnectionType.Unknown:
      return '-';
    case InternetConnectionType.NoConnection:
      return noConnectionText(language);
    case InternetConnectionType.G2:
      return '2G';
    case InternetConnectionType.G3:
      return '3G';
    case InternetConnectionType.G4:
      return '4G';
    case InternetConnectionType.G5:
      return '5G';
    case InternetConnectionType.WiFi:
      return 'WiFi';
  }
}
